<template>
  <div class="new-home2-page">
    <game-header :bannerCode="bannerCode" :isShowBanner="true"  style="margin-top:0px;border-radius: 6px;overflow: hidden;"></game-header>
    <section class="home-options">
      <div class="home-options-container">
        <div class="home-options-slice-1" @mouseenter="play()"  @mouseleave="pause()">
            <div class="home-options-slice-1-content">
              <h2>{{List[0].List[0].fullName}}</h2>
              <!-- <p>11ic Sports offers excellent sports betting with diverse options and live in-play betting.</p> -->
              <p>{{List[0].List[0].platformDescribe}}</p>
              <button @click="handeleGoGame(List[0].List[0],List[0])">PLAY</button>
            </div>
            <img src="./img/PC-11ic-Sports@2x.png" alt="">
            <c-video ref="cvideo"></c-video>
        </div>
        <div class="home-options-slice-container">
          <div class="home-options-slice-2">
              <div class="home-options-slice-img">
                <img :src="$store.state.linkList.staticDomain + List[0].List[1].appLogoPic" alt="">
              </div>
                <div class="home-options-slice-content">
                  <h3>{{List[0].List[1].fullName}}</h3>
                  <!-- <p>Best odds in free market for trading and betting.</p> -->
                  
                  <p>{{List[0].List[1].platformDescribe}}</p>
                </div>
                <div class="home-options-slice-content-arrow" @click="handeleGoGame(List[0].List[1],List[0])">
                <img src="./img/Arrow.svg">
              </div>
          </div>
          <div class="home-options-slice-3">
            <div class="home-options-slice-img">
              <img :src="$store.state.linkList.staticDomain + List[0].List[2].appLogoPic" alt="">
              <!-- <img src="data:image/png;base64,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"> -->
            </div>
            <div class="home-options-slice-content">
              <h3>{{List[0].List[2].fullName}}</h3>
              <!-- <p>Unlimited games in your screen.</p> -->
               <p>{{List[0].List[2].platformDescribe}}</p>
            </div>
            <div class="home-options-slice-content-arrow" @click="handeleGoGame(List[0].List[2],List[0])">
              <img src="./img/Arrow.svg">
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="item.gameType != 3" class="home-game" v-for="(item,index) in List" :key="index">
        <div class="title-container">
          <h4>{{ $t(item.title) }}</h4>
          <button class="btn-more" @click="handeleMore(item)">MORE</button>
        </div>
        <div :class="item.gameType == 2 || item.gameType == -1 ? 'casino-list' : 'rummy-list'">
          <!-- {{ item }} -->
            <img v-if="item.gameType == 2 || item.gameType == -1" @click="handeleGoGame(c,item)"  v-for="(c,i) in item.List" :src="$store.state.linkList.staticDomain + c.pcLogoImg" alt="" :key="i">
            <div v-if="item.gameType != 2 && item.gameType != -1" @click="handeleGoGame(c,item)" v-for="(c,i) in item.List.slice(0,2)" class="home-rummy-slice" :class="'slice-lot-'+i" :key="i+c.id">
              <h3>{{ c.fullName }}</h3>
              <img :src="$store.state.linkList.staticDomain + c.pcLogoImg" alt="">
            </div>
        </div>
    </section>
  </div>
</template>

<script>
import GameHeader from '../game-header/game-header'
import { PENDANT_CRICKET_BANNER } from '../../assets/js/bannerCode'
import myMarquee from '../common/marquee/marquee-news';
import { mapState , mapMutations} from 'vuex'
import CVideo from './video'
import { common } from '@/common/index'
import { commonApi } from '@/common/index';
export default {
   components:{ GameHeader , myMarquee , CVideo},
    data(){
        return{
            bannerCode:PENDANT_CRICKET_BANNER,
            List:[],
            allGameList:[
                { title:'newHome.sport',List:[],type:'sport',gameType:'3'},
                { title:'newHome.live',List:[],type:'live',gameType:'2'},
                { title:'newHome.hotgames',List:[],type:'hotgames',gameType:'-1'},
                { title:'newHome.chess',List:[],type:'chess',gameType:'6'},
                { title:'newHome.lottery',List:[],type:'lottery',gameType:'4'},
            ],
        }
    },
    created(){
      this.getAllPlatform()
    },
    methods: {
      ...mapMutations([ "setshowloginfloat2"]),
      // handleGoInside({ type }){
      //   this.$router.push({ path: '/games', query: { type:type } })
      // },
      play(){
        // console.log('播放',this.$refs.cvideo.$refs.videoPlayer)
        this.$refs.cvideo.$refs.videoPlayer.player.play();
      },
      pause(){
          // console.log('暂停')
        this.$refs.cvideo.$refs.videoPlayer.player.pause();
      },
      handeleMore(item){
        if(item.gameType == '2'){  //真人
          this.$router.push('/games')
        }else if(item.gameType == '6'){ //棋牌
          this.$router.push('/games')
        }else if(item.gameType == "4"){  //彩票
          this.$router.push('/games')
        } 
      },
      handeleGoGame(item,val){
        if(this.$store.state.isLogin){
          if(val.type == "slot"){
            this.$router.push({ path: '/games', query: { platformCode: item.platformCode,type:'slot' } })
          }else if(item.platformCode =='GT' && item.gameType == '4'){ // 彩票  gt  进内页
            let lotteryId = item.platformKey.replace('GT_LOTTERY_', '') || '3'
            this.$router.push({ path: '/games', query: { type:val.type,lotteryId } })
          } else{   // 其他所有近游戏
            common.jinsha_GoGame(item,this.$store.state.isLogin,this.$store.state.UUID)
          }
        }else{
          if(val.type == "slot"){  // 电子全进内页
            this.$router.push({ path: '/games', query: { platformCode: item.platformCode,type:'slot' } })
          }else{
            this.$notify({
              title:this.$t('notify.warning'),
              message:this.$t('newHome.login'),
              type: "warning",
            });
            this.setshowloginfloat2(true);
          }
        }
      },
      async getAllPlatform() {   // InGamePlatformGroup
        this.loading = true
        let hotList =  await commonApi.GAME.newHeatGamePlatform()
        // console.log(hotList,123,typeof(hotList))
        this.$api.post(this.$urls.SLOT.InGamePlatformGroup, {}, resp => {
          if(resp.data.code == 200){
            this.loading = false
            let data = resp.data.data
            this.List =[]
            this.allGameList.forEach(o => {
              if (data[o.gameType]) {
                this.List.push({ ...o,List:data[o.gameType] })
              }
              if(o.gameType == -1 && typeof(hotList) === 'object'){
                hotList.forEach((item) =>{
                  item.pcLogoImg = item.pcImg
                })
                this.List.push({ ...o,List:hotList })
              }
            })
          }else{
            this.loading =false
            this.List = []
          }
        })
      },
    },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
.new-home2-page{
    width:1430px;
    margin:0 auto;
    padding:20px 0;
    z-index:1;
    position: relative;
    .home-options{
      padding-top:15px;
      height:380px;
      .home-options-container{
        display: flex;
        height:100%;
        .home-options-slice-1{
          position: relative;
          background-image: url(./img/PC-11ic-Sports-BG@2x.png);
          width: 70%;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: cover;
          height: auto;
          position: relative;
          border-radius: 15px;
          overflow: hidden;
          min-height: 260px;
          .home-options-slice-1-content{
            color: white;
            width: 40%;
            padding: 36px;
            margin-top: 8%;
            position: absolute;
            z-index:1;
            h2 {
                font-size: 2em;
                padding-bottom:1em;
            }
            p {
                opacity: 0.8;
            }
            button {
                color: black;
                font-weight: 600;
                background-color: white;
                padding: 6px 20px;
                border-radius: 5px;
                font-family: Roboto;
                box-shadow: none;
                border: 0;
                display: block;
                margin-top: 30px;
                cursor: pointer;
                transition: all 0.2s ease-in-out;
                &:hover {
                    opacity: 0.8;
                }
            }
          }
          img{
            display: block;
            position: absolute;
            height: 100%;
            right: 0;
            z-index:1;
          }
        }
        .home-options-slice-container{
          flex: 1;
          display: flex;
          flex-flow: column;
          .home-options-slice-2 {
              flex:1;
              display: flex;
              background-color: #3F403C;
              color: white;
              position: relative;
              padding: 15px;
              margin: 0 15px 15px;
              border-radius: 15px;
              transition: all 0.2s ease-in-out;
          }
          .home-options-slice-3 {
              flex:1;
              display: flex;
              background-color: #3F403C;
              color: white;
              position: relative;
              padding: 15px;
              border-radius: 15px;
              margin: 0 15px 0;
              transition: all 0.2s ease-in-out;
          }
          .home-options-slice-img {
              background-color: #4A4C4A;
              border-radius: 15px;
              display: flex;
              align-items: center;
              padding: 15px;
              img {
                  display: block;
                  height: 22px;
                  width: 120px;
                  object-fit: contain;
              }
          }
          .home-options-slice-content {
              padding: 15px;
          }
          .home-options-slice-content-arrow {
              cursor: pointer;
              position: absolute;
              right: 0;
              background-color: #4A4C4A;
              height: 100%;
              top: 0;
              border-radius: 0px 15px 15px 0;
              display: flex;
              align-items: center;
          }
        }
      }
    }
    .home-game{
      margin-top: 20px ;
      .title-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #ffffff;
          h4{
            color: #fff;
            margin:20px 0;
          }
          .btn-more {
              color: black;
              font-weight: 600;
              background-color: white;
              padding: 6px 20px;
              border-radius: 5px;
              font-family: Roboto;
              box-shadow: none;
              border: 0;
              display: block;
          }
      }
      .casino-list{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        img{
          display: block;
          width: 11.5%;
          padding: 5px;
          border-radius: 15px;
          cursor: pointer;
          overflow: hidden;
          transition: all 0.2s ease-in-out;
          &:hover {
              transform: scale(1.1);
          }
        }
      }
      .rummy-list{
          display: flex;
          justify-content: space-between;
          .home-rummy-slice {
            width: 49.5%;
            display: flex;
            position: relative;
            align-items: center;
            border-radius: 15px;
            height: 200px;
            color: white;
            transition: all 0.3s ease-in-out;
            cursor: pointer;
            &.slice-lot-0 {
                background: linear-gradient(90deg, rgba(32, 30, 147, 1) 0%, rgba(86, 33, 237, 1) 100%);
                &:hover{
                  width: 85%;
                  margin-right: 15px;
                }
            }
            &.slice-lot-1 {
                background: linear-gradient(90deg, rgba(0, 105, 182, 1) 0%, rgba(0, 216, 177, 1) 100%);
                &:hover{
                  width: 85%;
                  margin-left: 15px;
                }
            }
            h3{
              padding-left: 15px;
              font-size: 1.4em;
            }
            img {
                display: block;
                height: 100%;
                position: absolute;
                right: 0;
                top: 0;
                border-radius: 0 15px 15px 0;
            }
        }
      }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/build902/components/new-home/new-home2.vue